<template>
    <main>

        <section class="vitirine-material-expirados pb-3" id="tab_pedidos">
            <header class="header-pagina">
                <h3>Meus pedidos</h3>
            </header>
            <div v-if="pedidos.items.length > 0">
                <div role="tablist">
                    <div class="card m-3 rounded" v-for="item in pedidos.items">
                        <div class="card-header bg-light">
                            <div class="row">
                                <div class="row col-9 btn-accordion-transparent" @click="item.isOpen = !item.isOpen;">
                                    <div class="col-5 col-md-5 pt-2">
                                        <h6>PEDIDO: <strong>{{ item.numeroPedido || item.pedidoId }}</strong></h6>
                                    </div>
                                    <div class="col-4 col-md-4 pt-2">
                                        <h6 v-if="!item.ehTroca">Valor Total: <strong>{{ formatPrice(item.valorLiquido) }}</strong></h6>
                                        <span v-if="item.ehTroca" class="badge badge-warning rounded-pill d-inline-flex align-items-center justify-content-center" style="font-size: 0.65rem; padding: 4px 10px;">Troca</span>
                                    </div>
                                    <div class="col-3 col-md-3 pt-2 text-center">
                                        <h6>{{ item.statusPedido ? item.statusPedido.nome : ''}}</h6>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <a href="javascript:;" @click="openAcompanharPedido(item)" class="btn btn-raised btn-success float-md-right mb-0 btn-sm">
                                        <i class="fas fa-search"></i> Detalhes do pedido
                                    </a>
                                </div>
                            </div>
                        </div>
                        <b-collapse visible accordion="my-accordion" role="tabpanel" :id="item.pedidoId" v-model="item.isOpen">
                            <div class="card-body">
                                <div class="jumbotron p-4 bg-light" v-for="pessoaProduto in item.collectionPessoaProduto">
                                    <div class="card" style="border-radius:10px;">
                                        <div class="row no-gutters">
                                            <div class="col-md-2 p-3">
                                                <img :src="pessoaProduto.produto.imagem" class="card-img" width="180">
                                                <div v-if="pessoaProduto.preVenda" class="overlay"></div>
                                                <div v-if="pessoaProduto.preVenda" class="pre-venda-text  pre-venda-text-pedido">
                                                    <span>&emsp;PRÉ-VENDA&emsp;</span>
                                                </div>
                                               

                                            </div>
                                            <div class="col-md-8">
                                                <div class="card-body">
                                                    <h6 class="card-title"><strong>{{ pessoaProduto.produto ? pessoaProduto.produto.nome : '' }}</strong></h6>
                                                    <div class="col-md-12 mb-2">
                                                        <hr class="my-2" />
                                                    </div>
                                                    <div class="row">

                                                        <div class="col-md-6">
                                                            <div class="mb-2">
                                                                <h6 class="mb-1"><strong>Escola</strong></h6>
                                                                {{ item.escola.nomeEscola}}
                                                            </div>
                                                            <div class="mb-2">
                                                                <h6 class="mb-1"><strong>Situação</strong></h6>
                                                                {{ item.statusPedido ? item.statusPedido.nome : ''}}
                                                            </div>
                                                            <div class="mb-2">
                                                                <h6 class="mb-1"><strong>Aluno</strong></h6>
                                                                {{pessoaProduto.nomeDestinatario}}
                                                            </div>
                                                            <div class="mb-2">
                                                                <h6 class="mb-1"><strong>Data início da aula/Data da prova:</strong></h6>
                                                                {{ pessoaProduto.dataAulaInicio ? pessoaProduto.dataAulaInicio : '--' }}
                                                            </div>
                                                            <div class="mb-2">
                                                                <h6 class="mb-1"><strong>Nº Item:</strong></h6>
                                                                {{ pessoaProduto.numeroItem }}
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <div class="mb-2">
                                                                <h6 class="mb-1"><strong>Data do pedido</strong></h6>
                                                                {{ item.dataStatusPedido }}
                                                            </div>
                                                            <div class="mb-2">
                                                                <h6 class="mb-1"><strong>Tipo do Produto</strong></h6>
                                                                {{pessoaProduto.produto.tipoProduto ? pessoaProduto.produto.tipoProduto.nome : ''}}
                                                            </div>

                                                            <div class="mb-2" v-if="pessoaProduto.permitirQuantidade && !item.ehTroca">
                                                                <h6 class="mb-1"><strong>Valor Unitário</strong></h6>
                                                                {{ formatPrice(pessoaProduto.valor) }}
                                                            </div>
                                                            <div class="mb-2" v-else-if="!item.ehTroca">
                                                                <h6 class="mb-1"><strong>Valor</strong></h6>
                                                                {{ formatPrice(pessoaProduto.valor) }}
                                                            </div>
                                                            <div class="mb-2" v-if="pessoaProduto.permitirQuantidade">
                                                                <h6 class="mb-1"><strong>Quantidade</strong></h6>
                                                                {{ pessoaProduto.quantidade }}
                                                            </div>
                                                            <div class="mb-2" v-if="pessoaProduto.permitirQuantidade && !item.ehTroca">
                                                                <h6 class="mb-1"><strong>Valor Total</strong></h6>
                                                                {{ formatPrice(pessoaProduto.valor * pessoaProduto.quantidade) }}
                                                            </div>
                                                            <div class="mb-2" v-if="!item.ehTroca">
                                                                <h6 class="mb-1"><strong>Desconto</strong></h6>
                                                                {{ formatPrice(pessoaProduto.valorDesconto) }}
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </b-collapse>
                    </div>
                </div>
                <div class="card-block no-padding">
                    <pagination :total="pedidos.total" :page-size="filterPedido.pageSize" :callback="executePageChanged"></pagination>
                </div>
            </div>
            <div v-if="pedidos.items.length <= 0">
                <p class="text-center py-4">Não há pedidos finalizados...</p>
            </div>
        </section>
        

        <b-modal :no-close-on-backdrop="true" size="xl" :no-close-on-esc="true" centered v-model="dialogAcompanharPedido" :hide-footer="true" title="Acompanhamento de Pedido">
            <acompanhamento v-if="dialogAcompanharPedido" :pedido="pedido" @on-back="hideAll()" />
        </b-modal>
    </main>
</template>
<script>
    import base from '@/common/base.js'
    import { Api } from '@/common/api'
    import acompanhamento from './acompanhamento'

    export default {
        name: 'pedidos',
        components: { acompanhamento },
        mixins: [base],
        props: {},
        data() {
            return {
                dialogAcompanharPedido: false,
                pedidos: {
                    total: 0,
                    items: []
                },
                filterPedido: {
                    pageSize: 10,
                    pageIndex: 1,
                    isPagination: true,
                },
            }
        },
        methods: {
            getPedidos() {
                this.filterPedido.attributeBehavior = "takePedidosToHome"
                new Api("pedido").get(this.filterPedido).then(data => {
                    if (data.summary) this.pedidos.total = data.summary.total;
                    data.dataList = data.dataList.map(_ => {
                        _.isOpen = false;
                        return _;
                    });
                    this.pedidos.items = data.dataList;
                    //console.log("pedidos", this.pedidos.items);
                }, err => {
                    this.defaultErrorResult(err);
                });
            },
            openAcompanharPedido(pedido) {
                if (pedido.pedidoPagamento && pedido.pedidoPagamento.formaPagamentoId == 7 && pedido.pedidoPagamento.statusGatewayId == 3) {
                    pedido.attributeBehavior = "CancelarPedidoPorPixVencido";
                    
                    new Api("pedido").post(pedido).then(data => {
                        if (data.data.statusPedidoId == 7) {
                            this.defaultSuccessResult("Pedido cancelado devido a expiração da data de validade do QR Code do PIX")
                            setTimeout(() => this.$router.go(this.$router.currentRoute), 3000);
                        }
                        else {
                            this.pedido = pedido;
                            this.dialogAcompanharPedido = true;
                        }
                    }, err => {
                        this.defaultErrorResult(err);
                    });
                }
                else {
                    this.pedido = pedido;
                    this.dialogAcompanharPedido = true;
                }
            },
            hideAll: function () {
                this.dialogAcompanharPedido = false;
            },
            executePageChanged: function (index) {
                this.filterPedido = this.defaultPageChanged(this.filterPedido, index);
                this.getPedidos();
            },
        },
        mounted() {
            this.getPedidos();
        }
    };
</script>

<style>

    @media(max-width: 991px) {

        .pre-venda-text-pedido {
            top: 12%;
            font-size: 0.9em;
        }
    }

    @media(min-width: 992px) {

        .pre-venda-text-pedido {
            top: 21%;
            font-size: 1.4em;
        }
    }


    @media(min-width: 1200px) {

        .pre-venda-text-pedido {
            top: 25% !important;
            font-size: 1.4em;
        }
    }

    @media(max-width: 767px) {

        .pre-venda-text-pedido {
            top: 50%;
            font-size: 3.5em;
            transform: translate(-50%, -50%) rotate(-50deg);
        }
    }

    @media(max-width: 485px) {

        .pre-venda-text-pedido {
            top: 50%;
            font-size: 3.0em;
            transform: translate(-50%, -50%) rotate(-50deg);
        }
    }
</style>